import React, { useEffect, useState } from "react";

export default function Home() {
    const [deals, setDeals] = useState([]);

    useEffect(() => {
        fetch("/deals.json")
            .then((res) => res.json())
            .then((data) => setDeals(data))
            .catch((err) => console.error("Error loading deals.json:", err));
    }, []);

    return (
        <main className="flex flex-col">
            {/* Full width hero image */}
            <div className="w-full">
                <img
                    src="/images/header.png"
                    alt="Clayton Car Contracts"
                    className="w-full h-64 md:h-64 object-cover"
                />
            </div>

            {/* Content section */}
            <div className="max-w-6xl mx-auto px-4 py-8">
                <h2 className="text-2xl font-bold mb-4">
                    Welcome to Clayton Car Contracts
                </h2>
                <p className="text-slate-700 mb-6">
                    Clayton Car Contracts was founded by the Flynn family in Staffordshire in 1995.
                    Specialising in Contract hire, our 25+ years experience in the motor industry means when it comes to making the right choice, you’re in safe hands.
                </p>
                <p className="text-slate-700 mb-6">
                    So, whether you're looking for something specific or just wanted to get a general feel for what your budget might afford, take a look at our latest deals below or get in touch via phone or our contact form.
                </p>

                {/* Deals */}
                <h3 className="text-xl font-semibold mb-6">
                    We’ve rounded up our best deals for you to take a look at.
                </h3>
                {deals.length === 0 ? (
                    <p>No deals available.</p>
                ) : (
                    <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
                        {deals.slice(0, 6).map((deal) => (
                            <a
                                key={deal.id}
                                href={`#/deal/${deal.dateAdded}`}
                                className="border rounded-lg overflow-hidden shadow bg-white block"
                            >
                                <img
                                    src={deal.thumbnail || deal.image}
                                    alt={deal.title}
                                    className="w-full h-48 object-cover"
                                />
                                <div className="p-4">
                                    <h3 className="font-semibold">{deal.title}</h3>
                                    <p className="text-sm text-slate-600 truncate">{deal.description}</p>
                                    <p className="text-xs text-slate-500 mt-2">
                                        {new Date(deal.dateAdded).toLocaleDateString()}
                                    </p>
                                </div>
                            </a>
                        ))}
                    </div>

                )}
                <h3 className="text-xl font-semibold mb-6 text-end">
                    <a className="hover:underline" href="#/deals">See all our current offers >></a>
                </h3>
            </div>
        </main>
    );
}
